export default __webpack_public_path__ + "static/media/privilege-s-sport.df2cbcbc.svg";